/**
 * Created by Rodrigo Quesada on 14/08/17.
 */
import {NgModule} from '@angular/core';
import {MessageService} from './message.service';

@NgModule({
    providers: [MessageService]
})
export class MessagesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/messages/messages.module.ts